var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.828,
    height: 14.828,
    viewBox: "0 0 14.828 14.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12951",
    "data-name": "Group 12951",
    transform: "translate(-1127.898 -531.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12074",
    "data-name": "Group 12074",
    transform: "translate(1129.313 539)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 8.485,
    transform: "translate(12 0) rotate(135)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 8.485,
    transform: "translate(6 6) rotate(-135)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12950",
    "data-name": "Group 12950",
    transform: "translate(1129.313 533)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_12-2",
    "data-name": "Line 12",
    x2: 8.485,
    transform: "translate(12 0) rotate(135)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13-2",
    "data-name": "Line 13",
    x2: 8.485,
    transform: "translate(6 6) rotate(-135)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.7fcff65a9ef15eb608d6ec69a563d04d.svg";
export { ForwardRef as ReactComponent };